import(/* webpackMode: "eager", webpackExports: ["Polyfills"] */ "/vercel/path0/components/globals/Polyfills/index.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientRootLayout"] */ "/vercel/path0/components/globals/RootLayout/index.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ui/StoryblokPreviewToaster/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
